import { useMatch } from "react-router";

import { useDataContext } from "../components/DataProvider";
import { ADVERTISER_ROUTE } from "../helpers/constants";

export const useCompanyInfo = () => {
	const { companyInfo, inStateMoveCompanyInfo, defaultInStateMoveCompanyInfo } =
		useDataContext();
	const {
		params: { advertiserName },
	} = useMatch(ADVERTISER_ROUTE);

	if (advertiserName === companyInfo.companySlug) {
		return companyInfo;
	}

	if (
		defaultInStateMoveCompanyInfo &&
		advertiserName === defaultInStateMoveCompanyInfo.companySlug
	) {
		return defaultInStateMoveCompanyInfo;
	}

	return inStateMoveCompanyInfo;
};
